import { render } from "./PpcSbProductPrioritization.vue?vue&type=template&id=f54367ea&scoped=true"
import script from "./PpcSbProductPrioritization.vue?vue&type=script&lang=js"
export * from "./PpcSbProductPrioritization.vue?vue&type=script&lang=js"

import "./PpcSbProductPrioritization.vue?vue&type=style&index=0&id=f54367ea&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f54367ea"]])

export default __exports__